import styled, { css } from 'styled-components'

export const AlgoliaSearch = styled.div`
  padding-top: ${({ theme }) => theme.rem(24)};
  padding-bottom: ${({ theme }) => theme.rem(24)};

  /* ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(40)};
    padding-bottom: ${theme.rem(40)};
  `)} */

  ${({ theme }) => css`

  `}
`
